import IMAGES from "../data/imageMap";
import { useSiteContent } from "../contexts/SiteContent";

export default function WhyScience() {
  const { t } = useSiteContent();
  return (
    <section data-testid="why-science" className="bg-[#f6f7f8] py-16 md:py-24 lg:py-28">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-7">
            <p className="text-[13px] uppercase tracking-[0.18em] font-medium text-neutral-600">
              {t("why_science.eyebrow", "AI for science")}
            </p>
            <h2 className="mt-5 text-[28px] sm:text-[32px] lg:text-[40px] leading-[1.15] font-semibold tracking-[-0.02em] text-neutral-900">
              {t(
                "why_science.statement",
                "Scientific discovery is the engine of human progress. But society's most pressing challenges are more vast and complex than ever before."
              )}
            </h2>

            <div className="mt-8 space-y-5 text-[16px] leading-relaxed text-neutral-700 max-w-[640px]">
              <p>
                {t(
                  "why_science.paragraph_1",
                  "By combining specialist scientific models with general-purpose reasoning systems, our research teams are building tools that shorten the path from question to insight — across biology, chemistry, climate, and the algorithmic foundations that connect them all."
                )}
              </p>
              <p>
                {t(
                  "why_science.paragraph_2",
                  "None of this happens in isolation. We work alongside academic labs, public health agencies, and open-source communities to put these tools where they're needed most, and to make sure each new capability is grounded in rigorous, reproducible science."
                )}
              </p>
            </div>
          </div>

          <div className="lg:col-span-5 grid grid-cols-2 gap-4 md:gap-5">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden bg-neutral-200 col-span-1 row-span-2 mt-6 lg:mt-0">
              <img src={IMAGES.why[1]} alt="" loading="lazy" className="w-full h-full object-cover" />
            </div>
            <div className="aspect-[4/5] rounded-2xl overflow-hidden bg-neutral-200 col-span-1">
              <img src={IMAGES.why[2]} alt="" loading="lazy" className="w-full h-full object-cover" />
            </div>
            <div className="aspect-[4/5] rounded-2xl overflow-hidden bg-neutral-200 col-span-1 hidden md:block">
              <img src={IMAGES.featured[3]} alt="" loading="lazy" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
